module.exports = __webpack_public_path__ + "img/hnhk.25a03a3b.png";